import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5015/api/v1';

const getHeaders = () => {
  const token = localStorage.getItem('knkt_pe_token') || localStorage.getItem('knkt_ue_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const campaignsAPI = {
  list: (params = {}) =>
    axios.get(`${BASE}/campaigns`, { headers: getHeaders(), params }).then(r => r.data),

  get: (id) =>
    axios.get(`${BASE}/campaigns/${id}`, { headers: getHeaders() }).then(r => r.data),

  create: (data) =>
    axios.post(`${BASE}/campaigns`, data, { headers: getHeaders() }).then(r => r.data),

  update: (id, data) =>
    axios.put(`${BASE}/campaigns/${id}`, data, { headers: getHeaders() }).then(r => r.data),

  delete: (id) =>
    axios.delete(`${BASE}/campaigns/${id}`, { headers: getHeaders() }).then(r => r.data),

  send: (id) =>
    axios.post(`${BASE}/campaigns/${id}/send`, {}, { headers: getHeaders() }).then(r => r.data),

  getSegments: () =>
    axios.get(`${BASE}/segments`, { headers: getHeaders() }).then(r => r.data),

  getSegmentCount: (key) =>
    axios.get(`${BASE}/segments/${key}/count`, { headers: getHeaders() }).then(r => r.data),
};

export default campaignsAPI;
